import { Controller } from "@hotwired/stimulus"
import { formValidation, plugins } from "formvalidation"
import Bootstrap3 from "formvalidation/plugins/Bootstrap3"

export default class extends Controller {
  static targets = [
    "form",
    "submitButton",
    "hostField",
    "hostLabel",
    "clientIdField",
    "clientIdLabel",
    "clientSecretField",
    "clientSecretLabel"
  ]

  connect() {
    this.setupFormValidation()

    this.hostFieldTarget.addEventListener("input", this.validateField.bind(this, "host"))
    this.clientIdFieldTarget.addEventListener("input", this.validateField.bind(this, "clientId"))
    this.clientSecretFieldTarget.addEventListener("input", this.validateField.bind(this, "clientSecret"))
  }

  setupFormValidation() {
    this.fv = formValidation(
      this.formTarget,
      {
        plugins: {
          bootstrap3: new Bootstrap3(),
          trigger: new plugins.Trigger({
            event: "blur"
          })
        },
        fields: {
          host: {
            selector: '[name="integrations_halo_psa[host]"]',
            validators: {
              notEmpty: { message: "Host is required." },
            }
          },
          clientId: {
            selector: '[name="integrations_halo_psa[client_id]"]',
            validators: {
              notEmpty: { message: "Client ID is required." },
            }
          },
          clientSecret: {
            selector: '[name="integrations_halo_psa[client_secret]"]',
            validators: {
              notEmpty: { message: "Client Secret is required." },
            }
          }
        }
      }
    )

    this.fv.on("core.field.invalid", (field) => this.toggleLabel(field, true))
    this.fv.on("core.field.valid", (field) => this.toggleLabel(field, false))
  }

  validateField(field) {
    // Trigger the validate so the `core.field.valid/invalid`
    // callback can run and update the label color
    this.fv.validateField(field)
    this.toggleButtonDisable()
  }

  toggleLabel(field, invalid) {
    // Same red used by `formValidation`
    this[`${field}LabelTarget`].style.color = invalid ? "#E74C3C" : null
  }

  toggleButtonDisable() {
    // Not running this.fv.validate here to prevent the
    // form fields from all being validated and turning red
    const allFilledOut = (
      this.hostFieldTarget.value.length > 0 &&
      this.clientIdFieldTarget.value.length > 0 &&
      this.clientSecretFieldTarget.value.length > 0
    )

    this.submitButtonTarget.disabled = !allFilledOut
  }
}
